module.exports = __webpack_public_path__ + "static/media/marker-label-CFA.39bd3c80.svg";